import type { ComponentType, PropsWithChildren } from 'react'

import { OverviewSection } from '../../overview/OverviewSection'

type Props = PropsWithChildren<{
  MemberIcon: ComponentType
  NameAndDeathStatus?: ComponentType
}>

export const ParticipantSectionLayout = ({
  children,
  MemberIcon,
  NameAndDeathStatus,
}: Props) => (
  <div className="grid grid-cols-[auto_1fr] gap-2">
    <MemberIcon />
    <OverviewSection>
      {NameAndDeathStatus && <NameAndDeathStatus />}
      <div className="flex gap-2">{children}</div>
    </OverviewSection>
  </div>
)
